<template>
  <div
    class="login-mask-layer"
    v-show="MASK_ACTIVE"
    @click.self="closeMask"
    @mousewheel.stop.prevent
  >
    <section class="login-page">
      <div class="login-container">
        <div class="adorn-hr-right">
          <div class="adorn-hr-right-1">
            <div class="login-outer">
              <template v-for="(item, index) in loginType">
                <div
                  class="login-button"
                  :class="`login-button-${item.name}`"
                  :key="`login-button-${index}`"
                  @click="snsLogin(item.name)"
                >
                  <img class="login-icon" :src="item.icon" :alt="item.name" />
                </div>
              </template>
            </div>
            <i class="adorn-hr-bottom"></i>
          </div>
          <div class="adorn-hr-right-2"></div>
        </div>

        <div class="login-content">
          <img src="../assets/images/login/logo.png" class="logo" alt />
          <div class="login-form">
            <div class="login-input" v-if="NAME_CHILD">
              <div class="login-email-box">
                <input
                  type="email"
                  class="login-email"
                  placeholder="メールアドレスをご入力ください"
                  v-model.trim="yostarEmail"
                />
              </div>
            </div>
            <div class="login-input" v-if="NAME_CHILD">
              <div class="login-code-box">
                <div class="login-code">
                  <input
                    type="text"
                    placeholder="認証コードをご入力ください"
                    class="login-code-input"
                    v-model="code"
                    maxlength="10"
                  />
                </div>
                <button
                  class="login-code-button"
                  @click="checkoutYostarEmail"
                  v-text="waitShow ? `${waitTime}s` : '送信'"
                ></button>
              </div>
            </div>
            <div class="login-input input-nickname" v-if="!NAME_CHILD">
              <div class="login-nickname-box">
                <input
                  type="text"
                  v-model.trim="nickname"
                  placeholder="ニックネームを入力してください"
                  class="login-nickname"
                  maxlength="12"
                />
              </div>
            </div>
            <!-- <p
            class="login-nickname-tip"
            v-if="!onlyNickName"
            >Login was successful. Please give yourself a nickname to continue.</p>-->
            <!-- v-if="onlyNickName" -->
            <p class="login-nickname-tip" v-if="!NAME_CHILD">
              *ニックネームは変更できません
            </p>
            <div class="yostar-login-box">
              <button class="login-in-button" @click="login">ログイン</button>
              <button class="cancel-button" @click="cancelLogin">キャンセル</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoginMask",

  components: {},
  data: () => ({
    loginType: [
      {
        name: "twitter",
        icon: require("../assets/images/login/twitter_icon.png"),
      },
      // {
      //   name: "facebook",
      //   icon: require("../assets/images/login/fb_icon.png"),
      // },

      {
        name: "apple",
        icon: require("../assets/images/login/apple_icon.png"),
      },
      // {
      //   name: "yostar",
      //   icon: require("../assets/images/login/yostar.png"),
      // },
    ],

    newWindow: "",
    loopTimer: null,
    // onlyNickName: false,

    waitShow: false,
    waitTime: 60,
    waitTimer: null,

    yostarEmail: "",
    code: "",
    nickname: "",
  }),
  created() {
    // if (this.$route.query.nickname) {
    //   this.onlyNickName = true;
    // }
    // this.$store.commit("User/SET_NAME_CHILD", false);
  },
  mounted() {},
  watch: {
    // $route(val) {
    //   this.onlyNickName = this.$route.query.nickname;
    // },
    waitShow(val) {
      if (val) {
        // 开启定时器
        this.waitTimer = setInterval(() => {
          this.waitTime = this.waitTime - 1;
          if (this.waitTime <= 0) {
            // 清除
            clearInterval(this.waitTimer);
            this.waitTimer = null;
            this.waitTime = 60;
            this.waitShow = false;
          }
        }, 1000);
      }
    },
  },
  computed: {
    ...mapState({
      LOGIN_TYPE: (state) => state.User.LOGIN_TYPE,
      MASK_ACTIVE: (state) => state.LoginMask.MASK_ACTIVE,
      NAME_CHILD: (state) => state.User.NAME_CHILD, //玩家起名
    }),
  },
  methods: {
    closeMask() {
      if(this.$route.name === 'upload') {
        return
      }
      this.$store.commit("LoginMask/SET_MASK_ACTIVE", false);
      this.yostarEmail = "";
      this.code = "";
      this.nickname = "";
    },
    iconShow(type) {
      if (this.NAME_CHILD) {
        return type !== this.LOGIN_TYPE;
      } else {
        return type !== "yostar";
      }
    },
    checkoutYostarEmail() {
      if (this.waitShow) {
        return false;
      }
      if (!this.$utils.checkEmail(this.yostarEmail)) {
        return alert("正しいメールアドレスを入力してください。");
      }

      this.axios
        .get("/auth/yostar_request", {
          params: {
            account: this.yostarEmail,
          },
        })
        .then((v) => {
          // console.log(v)
          if (v.retcode == 2000) {
            // 成功
            this.waitShow = true;
          } else if (v.retcode == 50003) {
            // 邮箱发送频率过高
            alert("認証頻度が高すぎます。時間を置いて再度お試しください。");
          } else if (v.retcode == 50004) {
            // 邮箱被封
            alert("このメールアドレスは使用できません。");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    login() {
      if (this.NAME_CHILD != true) {
        if (!this.nickname) {
          return false;
        }
        this.axios
          .get("/auth/set_nickname", {
            params: {
              nickname: this.nickname,
            },
          })
          .then((v) => {
            // console.log(v)
            if (v.retcode == 2000) {
              this.$store.commit("User/SET_LOGIN_TYPE", "yostar");

              // 成功
              this.$store
                .dispatch("User/getUserInfo")
                .then((v) => {
                  //  this.$store.commit("User/SET_NAME_CHILD", false);
                  // console.log(v)
                  if (v.retcode == 2000) {
                    this.cancelLogin();
                  }
                })
                .catch((e) => {
                  console.log(e);
                });
            } else if (v.retcode == 5005) {
              // 已经设置过昵称
              alert("ニックネームは設定済です。");
            } else if (v.retcode == 5004) {
              alert("同じニックネームがすでに存在しています。");
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        if (!this.$utils.checkEmail(this.yostarEmail)) {
          return alert("正しいメールアドレスを入力してください。");
        } else if(!this.code) {
          return alert("認証コードを入力してください。");
        }
        this.axios
          .get("/auth/yostar_login", {
            params: {
              account: this.yostarEmail,
              code: this.code,
            },
          })
          .then((v) => {
            // console.log(v)
            if (v.retcode == 2000) {
              // 成功
              this.$store
                .dispatch("User/getUserInfo")
                .then((v) => {
                  // console.log(v)
                  if (v.retcode == 2000) {
                    this.cancelLogin();
                  }
                })
                .catch((e) => {
                  console.log(e);
                });
            } else if (v.retcode == 50016) {
              // 验证失败，30分钟超时，或验证码不一致
              alert("認証コードが正しくありません。");
            } else if (v.retcode == 50009) {
              // 20次失败
              alert(
                "認証失敗回数が20回に達しました。別のメールアドレスでお試しください。"
              );
            } else if (v.retcode == 50004) {
              // 账户被封禁
              alert("このメールアドレスは使用できません。");
            } else if (v.retcode == 1) {
              // 提供的Yostar账号并未绑定过游戏账号
              alert("ゲームアカウントと連携されていないアカウントです。");
            } else if (v.retcode == 2) {
              // 提供的Yostar的token及uid在API中验证失败
              alert("認証失敗。");
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    snsLogin(sns) {
      this.yostarEmail = "";
      this.code = "";
      this.$store.commit("User/SET_LOGIN_TYPE", sns);
      if (sns !== "yostar") {
        // 开新窗口
        clearInterval(this.loopTimer);
        this.newWindow = this.$utils.openLogin(sns);
        this.loopTimer = setInterval(() => {
          if (this.newWindow.closed) {
            // 关闭窗口
            console.log("newWindow is closed.");
            clearInterval(this.loopTimer);
            this.$store
              .dispatch("User/getUserInfo")
              .then((v) => {
                console.log(v);
                if (v.retcode == 2000) {
                  this.cancelLogin();
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        }, 500);
      } else {
        // this.$store.commit("LoginMask/SET_MASK_ACTIVE", true);
        this.$router.replace({
          path: this.$route.path,
          query: Object.assign({}, this.$route.query, { nickname: false }),
        });
      }
    },
    cancelLogin() {
      // 返回之前的页面
      // if (this.$route.query.redirect) {
      //   this.$router.push({
      //     path: this.$route.query.redirect,
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/",
      //   });

      // }
      this.$store.commit("LoginMask/SET_MASK_ACTIVE", false);
      this.yostarEmail = "";
      this.code = "";
      this.nickname = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.login-mask-layer {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;

  .login-page {
    width: 100%;
    background: url(../assets/images/login/modal.png);
    background-size: cover;
    background-position: center top;
    overflow: hidden;
    width: pxTorem(555px);
    height: pxTorem(406px);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    .login-container {
      width: 100%;
      height: 100%;

      .adorn-hr-right {
        position: absolute;
        right: pxTorem(57px);
        top: pxTorem(62px);

        .adorn-hr-right-1 {
          width: pxTorem(2px);
          height: pxTorem(283px);
          position: relative;
          display: flex;
          flex-direction: column;

          &::before {
            content: "";
            display: block;
            width: 100%;
            background: #C3C3C3;
            flex: 1;
          }
          .adorn-hr-bottom {
            display: block;
            width: 100%;
            flex: 1;
            background: #C3C3C3;
            position: relative;

            &::after {
              content: "";
              display: block;
              width: 100%;
              background: #C3C3C3;
              height: pxTorem(25px);
              position: absolute;
              top: 100%;
              transform: rotate(50deg);
              transform-origin: right top;
            }
          }

          .login-outer {
            width: pxTorem(50px);
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin: pxTorem(9px) 0;

            .login-button {
              width: 100%;
              height: pxTorem(50px);
              cursor: pointer;

              &:not(:last-of-type) {
                margin-bottom: pxTorem(10px);
              }

              .login-icon {
                display: block;
                width: 100%;
              }

              &.login-button-yostar {
                background: #000;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;

                .login-icon {
                  width: 70%;
                }
              }
            }
          }
        }
      }
      .login-content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo {
          margin-top: pxTorem(62px);
          margin-bottom: pxTorem(35.5px);
          display: block;
          width: pxTorem(236px);
        }
        .login-form {
          width: pxTorem(351px);

          .login-input {
            width: 100%;
            height: pxTorem(46px);
            border: 1px solid #C9C9C9;
            box-sizing: border-box;
            font-size: 0;

            &::after {
              content: "";
              display: block;
              width: 100%;
              height: pxTorem(2px);
              background: #E6D312;
            }
            &:nth-of-type(1),
            &:nth-of-type(2) {
              margin-bottom: pxTorem(25px);
            }
            &.input-nickname {
              margin-top: pxTorem(48px);
              margin-bottom: pxTorem(10px);
            }

            .login-email-box {
              width: 100%;
              height: pxTorem(43px);

              .login-email {
                width: 100%;
                height: 100%;
                @include clearInput;
                color: #000;
                font-size: pxTorem(16px);
                line-height: pxTorem(43px);

                &::placeholder {
                  color: #999999;
                }
              }
            }
            .login-code-box {
              width: 100%;
              height: pxTorem(43px);
              display: flex;

              .login-code {
                flex: 1;

                .login-code-input {
                  @include clearInput;
                  width: 100%;
                  height: 100%;
                  color: black;
                  font-size: pxTorem(16px);
                  line-height: pxTorem(43px);

                  &::placeholder {
                    color: #999999;
                  }
                }
              }
              .login-code-button {
                color: #333;
                width: pxTorem(100px);
                height: 100%;
                background: #E6D312;
                line-height: pxTorem(43px);
                font-size: pxTorem(17px);
                font-weight: bold;
                cursor: pointer;
              }
            }
            .login-nickname-box {
              width: 100%;
              height: pxTorem(43px);

              .login-nickname {
                width: 100%;
                height: 100%;
                @include clearInput;
                color: black;
                font-size: pxTorem(16px);
                line-height: pxTorem(43px);

                &::placeholder {
                  color: #999999;
                }
              }
            }
          }
          .login-nickname-tip {
            font-size: pxTorem(14px);
            color: #a0a0a0;
          }
          .yostar-login-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: pxTorem(21px);

            .login-in-button,
            .cancel-button {
              width: pxTorem(155px);
              height: pxTorem(36px);
              background: #E6D312;
              color: #000;
              font-size: pxTorem(17px);
              line-height: pxTorem(36px);
              text-align: center;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
